import store from '~/javascripts/store';
import { observer } from 'mobx-react';

const EmailConsentCheckbox = observer(() => (
  <>
    {!store.donateForm.isUserLoggedIn && (
      <div className='custom-check'>
        <input
          defaultChecked={store.donateForm.emailConsentGranted}
          id='email-consent-granted'
          name='email_consent_granted'
          onChange={() =>
            (store.donateForm.emailConsentGranted =
              !store.donateForm.emailConsentGranted)
          }
          type='checkbox'
          value={store.donateForm.emailConsentGranted}
        />
        <label htmlFor='email-consent-granted'>
          Would you like to get our emails to stay in the know?
        </label>
      </div>
    )}
  </>
));

export default EmailConsentCheckbox;
